import { render, staticRenderFns } from "./waterproof.vue?vue&type=template&id=6a588d9c&scoped=true&"
import script from "./waterproof.vue?vue&type=script&lang=js&"
export * from "./waterproof.vue?vue&type=script&lang=js&"
import style0 from "./waterproof.vue?vue&type=style&index=0&id=6a588d9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a588d9c",
  null
  
)

export default component.exports